import React from 'react';

interface PdfViewerProps {
  pdfUrl: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl }) => {
  return (
    <div className="w-full h-full flex items-center justify-center p-4">
      <iframe 
        src={pdfUrl} 
        className="w-full h-full rounded-lg bg-white shadow-lg border-0" 
        title="PDF Viewer"
      />
    </div>
  );
};

export default PdfViewer;